<template>
  <div class="modal">
    <v-dialog
      persistent
      :value="value"
      @input="$emit('input')"
      transition="fade-transition"
      max-width="1300px"
      content-class="ims-standard-dialog"
    >
      <v-card class="ims-modal-card">
        <v-toolbar color="elevation-0" class="pairing-elimination-toolbar">
          <v-toolbar-title class="pairing-elimination-title">
            <h2 class="headline text-xs-center">
              Proposed Influencer List for "
              <strong>{{ campaign.name }}</strong>" campaign
            </h2>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon color="secondary" aria-label="Close" title="Close" @click="close()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <div class="ims-modal-body">
          <div class="pairing-elimination-options">
            <v-btn-toggle
              v-model="optionVal"
              mandatory
              color="secondary"
              @change="changeOption()"
            >
              <v-btn class="option-btn">Option A</v-btn>
              <v-btn class="option-btn">Option B</v-btn>
            </v-btn-toggle>
          </div>
          <v-card-text>
            <p v-html="termsAndCondition"></p>
          </v-card-text>
          <v-container fluid>
            <v-layout column>
              <v-flex xs12>
                <pairing-influencers-table
                  :influencers="pairedInfluencers"
                  elimination
                  :campaignID="campaign.id"
                  :campaignData="campaign"
                  @savedEliminationChanges="eliminationSubmitted"
                  @savedClientNotes="getPairingList"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </div>
        <v-card-actions class="ims-modal-actions">
          <v-spacer></v-spacer>
          <v-btn color="secondary" text @click="close()">Close</v-btn>
        </v-card-actions>
      </v-card>
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
        loader="bars"
        background-color="#000"
        color="secondary"
        width.number="90"
        height.number="90"
      />
    </v-dialog>
  </div>
</template>

<script>
import pairingInfluencersTable from '../Pairing/PairingDataTable.vue';
import pairingAPIs from '../Pairing/pairingAPIs';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import campaignConfig from './config';
import reverse from 'lodash/reverse';
import sortBy from 'lodash/sortBy';

export default {
  name: 'ViewPairingElimination',
  props: {
    value: Boolean,
    campaingData: Object
  },
  components: {
    pairingInfluencersTable,
    Loading
  },
  data() {
    return {
      isLoading: false,
      campaign: {},
      sortBy: 'name',
      sortDesc: false,
      items: [],
      allOptions: [],
      pairedInfluencers: [],
      headers: [
        {
          text: 'Action',
          sortable: false
        },
        {
          text: 'InstagramHandle',
          value: 'igHandle'
        },
        {
          text: 'Name',
          align: 'left',
          sortable: false,
          value: 'instagramFullname'
        },
        { text: 'Age', value: 'age' },
        { text: 'Gender', value: 'gender' },
        { text: 'Followers', value: 'totalFollowers' },
        { text: 'Engagement Rates', value: 'engagementRate' },
        { text: 'Location', value: 'country' },
        { text: 'Status', value: 'selected' }
      ]
    };
  },
  watch: {
    campaingData: function(campaign) {
      this.campaign = Object.assign({}, campaign);
      this.getPairingList();
    }
  },
  computed: {
    termsAndCondition: function() {
      return campaignConfig.campaignConfirmation.pairingTermsAndCondition.html;
    }
  },
  methods: {
    eliminationSubmitted() {
      this.getPairingList();
      this.close();
    },
    getPairingList() {
      this.isLoading = true;
      pairingAPIs.getPairedInfluencersByCampaign(this.campaign.id).then(response => {
        if (response.length > 0) {
          let pairedInfluencersRes = response.map(element => Object.assign(this.beautifyData(element)));
          this.pairedInfluencers = pairedInfluencersRes.sort((a, b) => a.lineUpIndex - b.lineUpIndex)
          this.allOptions = Object.assign([], this.pairedInfluencers)
          this.changeOption()
          this.isLoading = false;
        } else {
          this.pairedInfluencers = [];
          this.isLoading = false;
        }
      });
    },
    changeOption() {
      let optionShows = this.allOptions.filter(p => {
        if (this.optionVal === 0) {
          return !p.options || p.options === this.optionVal
        } else {
          return p.options && p.options === this.optionVal
        }
      })
      this.pairedInfluencers = Object.assign([], optionShows)
    },
    beautifyData(data) {
      // Client doesn't need payout_details, so it is removed in this beautifyData() function
      let inf = {};
      inf = data.influencer_details;
      const deliverablesDetails = data.deliverables_details || {};
      const additionalDetails = data.additional_details || {};
      const payoutDetails = data.payout_details || {};
      inf.remarks = additionalDetails.remarks;
      inf.contentFeature = additionalDetails.contentFeature || '';
      inf.pairingStatus = data.pairing_details.status;
      inf.eliminationStatus = data.elimination_details.status;
      inf.eliminationReason = data.elimination_details.reason;
      inf.no_of_posts = deliverablesDetails.no_of_posts || 0;
      inf.no_of_carousels = deliverablesDetails.no_of_carousels || 0;
      inf.no_of_video = deliverablesDetails.no_of_video || 0;
      inf.no_of_stories = deliverablesDetails.no_of_stories || 0;
      inf.no_of_tiktok_posts = deliverablesDetails.no_of_tiktok_posts || 0;
      inf.no_of_reels = deliverablesDetails.no_of_reels || 0;
      inf.options = data.options || 0
      inf.pairingID = data.id;
      inf.lineUpIndex = data.lineUpIndex;
      inf.platform = inf.platform || 'instagram'
      inf.platformName = inf.platformName || inf.platform;
      inf.clientNotes = data.clientNotes ? reverse(data.clientNotes) : [];
      inf.audience_genders = inf.audience_genders || []
      inf.topAudAges = []
      inf.topCountries = []
      inf.payoutDetails = payoutDetails
      if (inf.audAges) {
        if (inf.audAges.length > 1) {
          inf.audAges = sortBy(inf.audAges, 'lineupIndex');
          inf.topAudAges = [
            inf.audAges[0],
            inf.audAges[1]
          ]
        }
      }
      if (inf.countries) {
        if (inf.countries.length > 1) {
          inf.countries = sortBy(inf.countries, 'lineupIndex');
          inf.topCountries = [
            inf.countries[0],
            inf.countries[1]
          ]
        }
      }
      return inf;
    },
    close() {
      this.$emit('input');
    }
  }
};
</script>
<style scoped>
.pairing-elimination-toolbar {
  min-height: 56px;
  height: auto !important;
}

.pairing-elimination-toolbar >>> .v-toolbar__content {
  height: auto !important;
  min-height: 56px;
  padding-bottom: 8px;
  padding-top: 8px;
}

.pairing-elimination-title {
  flex: 1 1 auto;
  min-width: 0;
  white-space: normal;
}

.pairing-elimination-title .headline {
  margin: 0;
  overflow-wrap: anywhere;
}

.pairing-elimination-options {
  display: flex;
  justify-content: flex-end;
  padding: 12px 22px 0;
}

.option-btn.v-btn--active {
  background-color: var(--ims-color-secondary) !important;
  color: var(--ims-color-white) !important;
}
</style>



// WEBPACK FOOTER //
// ViewPairingInfluencerElimination.vue?4d2a661b